import { AdminAppState, PageEntry } from '../../state';
import { getPages } from './get-pages';

export const getPageEntry = (pageKey: string) => (
  state: AdminAppState,
): PageEntry => {
  const draft = getPages(state)[pageKey];
  if (draft) {
    return draft;
  } else {
    throw new Error(`Page draft not in store: ${pageKey}`);
  }
};
